module.exports = require('../../modules/_wks-ext').f('toPrimitive');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/to-primitive.js
// module id = 357
// module chunks = 54